import { loadGeoJSONToCesium } from "../geojson/LoadGeojson";
import Type from "../Types";
import { createUniqueId } from "../Utility";

export async function loadCSVTypeAsync({ text = null, fileName, geojsonImport = null, viewerRef, setMapObjects, defaultGeojsonStyle }) {
  return new Promise((resolve, reject) => {
    try {
      let geojson = geojsonImport;
      let laneletIds = []; // store lanelet IDs if exist

      // Parse CSV text if GeoJSON not provided
      if (!geojson && text) {
        const lines = text.trim().split("\n");
        const headers = lines[0].split(",").map((h) => h.trim().toLowerCase());

        const latIndex = headers.findIndex((h) => ["latitude", "lat"].includes(h));
        const lonIndex = headers.findIndex((h) => ["longitude", "lon", "lng"].includes(h));
        const heightIndex = headers.findIndex((h) => ["height", "altitude", "elevation"].includes(h));
        const laneletIndex = headers.findIndex((h) => h === "lanelet_id"); // new check

        const coords = [];
        for (let i = 1; i < lines.length; i++) {
          const row = lines[i].split(",").map((v) => v.trim());
          const lat = parseFloat(row[latIndex]);
          const lon = parseFloat(row[lonIndex]);
          const height = parseFloat(row[heightIndex]);

          if (!isNaN(lat) && !isNaN(lon) && !isNaN(height)) {
            coords.push([lon, lat, height]);
            // collect lanelet_id if present and valid
          }
          if (laneletIndex !== -1 && row[laneletIndex]) {
            laneletIds.push(row[laneletIndex]);
          }
        }

        geojson = {
          type: "FeatureCollection",
          features: [
            {
              type: "Feature",
              properties: { name: fileName },
              geometry: { type: "LineString", coordinates: coords },
            },
          ],
        };
      }

      if (!geojson) throw new Error("Invalid input: no CSV text or GeoJSON data");

      const id = createUniqueId();

      setMapObjects((prev) => [
        ...prev,
        {
          id,
          name: "CSV",
          type: Type.ASSET.CSV,
          file_name: fileName,
          file_type: ".csv",
          geojson,
          visible: true,
          dataSource: null,
          loading: true,
          lanelet_ids: laneletIds, // ← set collected lanelet IDs
        },
      ]);

      loadGeoJSONToCesium({
        viewer: viewerRef.current,
        geojson,
        options: { ...defaultGeojsonStyle },
        callback: (dataSource, geoJson, billboards, fill, outline, width, styleType) => {
          setMapObjects((prev) => {
            const copy = [...prev];
            const i = copy.findIndex((o) => o.id === id);
            if (i !== -1) {
              copy[i] = {
                ...copy[i],
                dataSource,
                billboards,
                style_stroke_width: width,
                style_fill_color: fill,
                style_outline_color: outline,
                style_type: styleType,
                loading: false,
              };
            }
            return copy;
          });
          resolve();
        },
        geojsonType: Type.ASSET.CSV,
        layerName: fileName,
      });
    } catch (e) {
      reject(e);
    }
  });
}
